export default __webpack_public_path__ + "static/media/avatar_04.1244ef6b.png";